import React from "react"
import { AnimatePresence } from "framer-motion"

export const wrapPageElement = ({ element }) => (
  <AnimatePresence exitBeforeEnter>{element}</AnimatePresence>
)

const preventScrollAnchors = [
  'karol', 'patrycja', 'emilia', 'piotr', 'karolina', 'wiola'
];

// Prevent automatic scrolling to hash elements
// This prevents Gatsby from scrolling to elements with id matching the hash
export const onRouteUpdate = ({ location }) => {
  if (location.hash && preventScrollAnchors.includes(location.hash.replace('#', ''))) {
    // Prevent default scroll behavior for hash navigation
    // Scroll to top instead of scrolling to the element with matching id
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 0)
  }
}

// must be on Gatsby v2.28 or later -- previous versions had a bug with getSavedScrollPosition that was resolved with v2.28
// wait until page exit animation has completed before updating scroll position
export const shouldUpdateScroll = ({
                                     routerProps: { location },
                                     getSavedScrollPosition
                                   }) => {
  // transition duration from `layout.js` * 1000 to get time in ms
  const TRANSITION_DELAY = 0.3 * 1000 * 2;

  // Prevent automatic scrolling to hash elements
  // When navigating with hash (e.g., /team#anchor), scroll to top instead
  if (location.hash && preventScrollAnchors.includes(location.hash)) {
    window.setTimeout(() => window.scrollTo(0, 0), TRANSITION_DELAY);
    return false;
  }

  // if it's a "normal" route
  if (location.action !== "PUSH") {
    // breaking change in shouldUpdateScroll browser API hook:
    // https://github.com/gatsbyjs/gatsby/issues/23842
    // looks like they fixed it in Gatsby v. 2.28.1
    // https://github.com/gatsbyjs/gatsby/pull/27384

    const savedPosition = getSavedScrollPosition(location) || [0, 0]

    window.setTimeout(() => window.scrollTo(...savedPosition), TRANSITION_DELAY);
    return false;
  }
  return true;
}
